import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../../Miscelania/RequestApi';

import { Modal } from 'react-bootstrap';

import TeamTrainingMatterStaffAcoesLinha from './TeamTrainingMatterStaffAcoesLinha';

class ModalAlunoMateria extends Component {
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed',        
      },
      redirect_url: false,
      dados: [],
      modal: false,
      loaded: 0,
      team_training_matter_staff_id: this.props.team_training_matter_staff_id,
    };
    this.loadData = this.loadData.bind(this);
    this.closeModal = this.closeModal.bind(this);
  }

  //LM
  componentWillReceiveProps(newProps) {
    if (newProps.modal === true && this.state.loaded === 0) {
      this.setState({loaded: 1});
      this.loadData(newProps.team_training_matter_staff_id);
    } else if (this.state.loaded === 1 && newProps.modal === true) {
      this.setState({ modal: true });
    }
  }

  loadData(event) {

    this.props.handleAlert('', '', 'open');

    var url = config.get('api') + '/aluno/provas/'+ event;
    var header = this.refs.request_api.header('application/json');
    var self = this;
    Promise.resolve(header).then(function(value) {
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson);
        if (responseJson.status === 'success') {
          self.setState({dados: responseJson.data});
        }
        self.setState({ modal: true });
        self.props.handleAlert('', '', 'closed');
      }).catch((error) => {
        console.error(error);

      });
    });
  }
  closeModal () {
    this.setState({ modal: false }, this.props.closeModal());
  }

  render() {
    var self = this;
    return (
      <div>
        <RequestApi ref={'request_api'} />
        <Modal show={this.state.modal} aria-labelledby="contained-modal-title-lg" bsSize={'large'}>
          <Modal.Header>
            <h4 className="pull-left">Resultados de aluno</h4>
            <button className="btn btn-danger btn-sm pull-right" onClick={this.closeModal}>
            <i className="fa fa-fw fa-close"></i></button>
            <div className="clearfix"></div>
          </Modal.Header>
          <Modal.Body>
            <table className="table table-bordered table-stripped table-hover">
              <thead>
                <tr>
                  <th >Nota</th>
                  <th >Resultado</th>
                  <th >Início e Término da Realização</th>
                  <th >Importado</th>
                  <th >Ações</th>
                </tr>
              </thead>
              <tbody>
              {self.state.dados.map(function(dado, index) {
                return (
                  <TeamTrainingMatterStaffAcoesLinha id={dado.id} handleAlert={self.props.handleAlert} team_traning_matter_staff_id={dado.team_traning_matter_staff_id} exam_applied_start_str={dado.exam_applied_start_str} exam_applied_finish_str={dado.exam_applied_finish_str} result={dado.result} imported_str={dado.imported_str} status_str={dado.status_str} RequestApi={self.refs.request_api}/>
                );
              })}
              </tbody>
            </table>
          </Modal.Body>
          <Modal.Footer>
            <button className="btn btn-danger btn-sm pull-right" onClick={this.closeModal}>
            <i className="fa fa-fw fa-close"></i></button>
          </Modal.Footer>
        </Modal>
      </div>
    );
  }
}

export default ModalAlunoMateria;



// WEBPACK FOOTER //
// ./src/Components/Teams/Elements/ModalAlunoMateria.js